import { render, staticRenderFns } from "./claims.vue?vue&type=template&id=d5ab8c14&scoped=true"
import script from "./claims.vue?vue&type=script&lang=js"
export * from "./claims.vue?vue&type=script&lang=js"
import style0 from "./claims.vue?vue&type=style&index=0&id=d5ab8c14&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5ab8c14",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d5ab8c14')) {
      api.createRecord('d5ab8c14', component.options)
    } else {
      api.reload('d5ab8c14', component.options)
    }
    module.hot.accept("./claims.vue?vue&type=template&id=d5ab8c14&scoped=true", function () {
      api.rerender('d5ab8c14', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/template/frontPageManage/configureManage/mobilePreview/components/claims.vue"
export default component.exports